// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__CLmRo","panelInner":"Panel_panelInner__WXORZ"};